module.exports = __webpack_public_path__ + "img/map-building.39e90943.svg";